import { useQueries, useQuery } from '@tanstack/vue-query';
import { type MaybeRefOrGetter, toValue } from 'vue';

import { type DigitalCoach, type User, MEMBER_TYPE } from '../@types';
import { keys } from '../keys';

export const useUsers = () => useQuery(keys.users.users);

export const useUser = (userUuid: MaybeRefOrGetter<string | undefined>) => useQuery(
  () => ({
    ...keys.users.user(toValue(userUuid) ?? ''),
    enabled: Boolean(toValue(userUuid)),
  }),
);

export const useUsersAndInvitations = () => useQueries({
  queries: [keys.users.users, keys.invitations.invitations],
  combine: ([usersResult, invitationsResult]) => ({
    errors: [usersResult.error, invitationsResult.error],
    isError: usersResult.isError || invitationsResult.isError,
    isLoading: usersResult.isLoading || invitationsResult.isLoading,
    data: [
      ...(usersResult.data?.data ?? []).map((user) => ({ ...user, type: MEMBER_TYPE.USER })),
      ...(invitationsResult.data?.data ?? []).map((invitation) => ({ ...invitation, type: MEMBER_TYPE.INVITATION })),
    ],
  }),
});

export const useUsersAndDigitalCoaches = () => useQueries({
  queries: [keys.users.users, keys.digitalCoaches.list],
  combine: (results) => ({
    data: results.flatMap<DigitalCoach | User>((result) => result.data?.data ?? []),
    errors: results.map((result) => result.error),
    isError: results.some((result) => result.isError),
    isFetching: results.some((result) => result.isFetching),
  }),
});
